import React, { Component } from 'react'
import PropTypes from 'prop-types'
import anime from 'animejs'

class Anime extends Component {
  constructor (props) {
    super(props)
    this.targets = []
  }

  componentDidMount () {
    this.createAnime(this.props)
  }

  shouldComponentUpdate (nextProps) {
    this.createAnime(nextProps)

    return true
  }

  createAnime = props => {
    let animeProps = Object.assign({}, { targets: this.targets }, props)

    delete animeProps.children

    this.anime = anime(animeProps)
  }

  addTarget = newTarget => {
    this.targets = [...this.targets, newTarget]
  }

  render () {
    let children = []
    if (this.props.children) {
      if (Array.isArray(this.props.children)) children = this.props.children
      else children = [this.props.children]
    }

    return (
      <g>
        {children.map((child, i) => {
          if (typeof child.type !== 'function') {
            return React.cloneElement(child, { key: i, ref: this.addTarget })
          } else {
            throw new Error(
              'animejs: You can only animate HTML elements. No React components.'
            )
          }
        })}
      </g>
    )
  }
}

Anime.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
}

export default Anime



// WEBPACK FOOTER //
// ./src/components/Anime/Anime.js